const bitmaskUtils = {
  test(haystack: number, needle: number) {
    return (needle & haystack) === needle;
  },
};

export default bitmaskUtils;
